__turbopack_context__.v({
  "errorText": "LanguageFormat-module-scss-module__OMgXvW__errorText",
  "selectedLabel": "LanguageFormat-module-scss-module__OMgXvW__selectedLabel",
  "translateError": "LanguageFormat-module-scss-module__OMgXvW__translateError",
});
